import { render, staticRenderFns } from "./QuickAccessList.vue?vue&type=template&id=bec07e3e&scoped=true&"
import script from "./QuickAccessList.vue?vue&type=script&lang=js&"
export * from "./QuickAccessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec07e3e",
  null
  
)

export default component.exports